import request from '@/CommonDP/service/login-service';
import requestprj from '@/CommonDP/service/integratedModel-service';
import {
  handleRoute,
  handleProjectRoute
} from '@/CommonDP/utils/routeAuth';
import secondaryMenu from "@/CommonDP/service/secondaryMenu-service";
export const knowledgeComponent = () => import("@/CommonDP/pages/mainMg/doc/enterpriseDeptDoc/index.vue");
import routerInit from '@/CommonDP/router';

const routeModule = {
  state: {
    buttonRoutes: [], // 权限按钮-系统
    flatRoutes: [], // 处理后端route组成的平级的完整route-系统
    authRoutes: [], // 最终传给vueRouter的树形route数组-系统

    buttonProjectRoutes: [], // 权限按钮-项目
    flatProjectRoutes: [], // 处理后端route组成的平级的完整route-项目
    authProjectRoutes: [], // 最终传给vueRouter的树形route数组-项目
    newsNumKey: 0,
    routerNav: [],
    hasRoles: true, // 只有刷新或者点击登录按钮, 还有设置为true时 才有作用
    repeatEnterpriseDept: true
  },
  getters: {
    // 当前项目和系统模块
    flatRoutes(state) {
      return [...state.flatRoutes, ...state.flatProjectRoutes];
    }
  },
  mutations: {
    // 存储按钮
    saveAuthButtons(state, data) {
      state.buttonRoutes = data;
    },
    // 存储自己本地对比组合后的平级路由数组
    saveFlatRoutes(state, data) {
      state.flatRoutes = data;
    },
    // 存储最终完成的传给vueRouter的树形路由数组
    saveAuthRoutes(state, data) {
      state.authRoutes = data;
    },

    // 存储按钮
    saveAuthProjectButtons(state, data) {
      state.buttonProjectRoutes = data;
    },
    // 存储自己本地对比组合后的平级路由数组
    saveFlatProjectRoutes(state, data) {
      state.flatProjectRoutes = data;
    },
    // 存储最终完成的传给vueRouter的树形路由数组
    saveAuthProjectRoutes(state, data) {
      state.authProjectRoutes = data;
    },
    SETNEWSNUMKEY(state, data) {
      state.newsNumKey = data;
    },
    SETROUTERNAV(state, data) {
      state.routerNav = data;
    },
    SETHASROLES(state, data) {
      state.hasRoles = data;
    },
    SETPEATENTERPRISEDEPT(state, data) {
      state.repeatEnterpriseDept = data;
    }
  },
  actions: {
    // 获取系统路由
    async GetModuleList({ commit }, data) {
      const store = require("@/store/index").default;
      const flatRoutes = store.state.router.flatRoutes;
      if (flatRoutes && flatRoutes.length > 0) {
        return true;
      }
      const enterpriseId = data || store.state.enterprise.enterpriseId;
      // unauthorized:企业状态 1代表企业能正常使用 110表示当前账号被企业禁用了 4表示企业被禁用了
      const unauthorized = store.state.enterprise.unauthorized;
      if (enterpriseId && Number(unauthorized) === 1) {
        const response = await request.getModuleList(enterpriseId);
        const result = response.data;
        handleRoute(result);
        return response;
      }
    },
    // 获取项目路由
    async getModuleProjectList({ rootState }, prjId = rootState.projectMg.prjId) {
      const enterpriseId = rootState.enterprise.enterpriseId;
      if (!prjId) {
        const { data } = await requestprj.queryPrj({
          enterpriseId,
          prjName: '',
          prjCode: '',
          prjType: '',
          prjLevel: ''
        });
        if (data?.length) { prjId = data[0].prjId; }
      }
      const response = await request.getModuleProjectList(enterpriseId, prjId);
      handleProjectRoute(response.data);
      return response;
    },
    async queryEnterpriseDept() {
      const store = require("@/store/index").default;
      const routerNav = store.state.router.routerNav;
      if (routerNav && routerNav.length > 0) {
        return true;
      }
      const router = routerInit();
      const enterpriseId = store.state.enterprise.enterpriseId;
      if (!enterpriseId) return false; // 没有企业id时，会报错
      const params = {
        folderId: "0",
        isRead: 1,
        priviAll: "1",
        enterpriseId: enterpriseId,
        type: "",
        versionId: ""
      };
      const { data } = await secondaryMenu.queryEnterpriseDept(params);
      const knowledgeArr = data.map((item) => {
        item.path = '/depDoc-' + item.folderId;
        item.name = item.folderId;
        item.component = knowledgeComponent;
        item.meta = {
          routeName: item.folderName,
          prouteName: '部门文档/' + item.folderId,
          ppname: '知识'
        };
        return item;
      });
      knowledgeArr.forEach(v => {
        router.addRoute('enterpriseDeptDoc', v);
      });
      store.dispatch("setRepeatEnterpriseDept", false);
      store.dispatch("setRouterNav", knowledgeArr);
    },
    // 退出清空权限
    logoutRouter({ commit }) {
      commit('saveAuthButtons', []);
      commit('saveFlatRoutes', []);
      commit('saveAuthRoutes', []);
      commit('saveAuthProjectButtons', []);
      commit('saveFlatProjectRoutes', []);
      commit('saveAuthProjectRoutes', []);
    },
    setNewsNumKey({ commit }, data) {
      commit('SETNEWSNUMKEY', data);
    },
    setRouterNav({ commit }, data) {
      commit('SETROUTERNAV', data);
    },
    setHasRoles({ commit }, data) {
      commit('SETHASROLES', data);
    },
    setRepeatEnterpriseDept({ commit }, data) {
      commit('SETPEATENTERPRISEDEPT', data);
    }
  }
};

export default routeModule;
